export default "__VITE_ASSET__vDbMjy41__"